<p-toast position="top-right"></p-toast>

<div class="p-6" data-testid="delivery-retry-config-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-2">
    {{ "delivery_retry_config.title" | translate }}
  </h2>
  <p class="text-sm text-gray-600 mb-6">
    {{ "delivery_retry_config.description" | translate }}
  </p>

  <div class="settings-card">
    <div class="field-row">
      <label for="retryDelayMinutes">
        {{ "delivery_retry_config.retry_delay_minutes" | translate }}
      </label>
      <p-inputNumber
        inputId="retryDelayMinutes"
        [ngModel]="config().retryDelayMinutes"
        (ngModelChange)="onMinutesChange($event)"
        (onBlur)="onMinutesBlur()"
        [min]="1"
        [max]="10080"
        [disabled]="!canUpdate() || loading() || saving()"
        data-testid="delivery-retry-delay-input"
      />
      <span class="hint">{{
        "delivery_retry_config.retry_delay_hint" | translate
      }}</span>
    </div>

    <div class="field-row toggle-row">
      <span class="toggle-label">
        {{ "delivery_retry_config.enabled" | translate }}
      </span>
      <p-toggleSwitch
        inputId="autoRetryEnabled"
        [ngModel]="config().enabled"
        (ngModelChange)="onEnabledChange($event)"
        [disabled]="!canUpdate() || loading() || saving()"
        data-testid="delivery-retry-enabled-toggle"
      />
    </div>
  </div>
</div>
